(function () {
  function initVideo(root) {
    var play = root.querySelector('[data-partnerships-play]');
    if (!play) return;
    play.addEventListener('click', function () {
      var videoId = play.getAttribute('data-youtube-id');
      if (!videoId) return;
      var frame = document.createElement('iframe');
      frame.className = 'partnerships-apply__iframe';
      frame.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1';
      frame.title = play.getAttribute('data-youtube-title') || 'YouTube video';
      frame.allow = 'autoplay; encrypted-media; picture-in-picture';
      frame.setAttribute('allowfullscreen', '');
      play.replaceWith(frame);
    });
  }

  function initForm(root) {
    var form = root.querySelector('[data-partnerships-form]');
    if (!form) return;

    var platforms = form.querySelectorAll('[data-platform]');
    var submitButton = form.querySelector('[type="submit"]');
    var profileUrl = form.querySelector('[data-profile-url]');
    var profileUrlValue = form.querySelector('[data-profile-url-value]');

    function profileRest(value) {
      return value.replace(/^\s*https?:\/\//i, '').trim().replace(/^\/+/, '');
    }

    function syncPlatforms() {
      if (!platforms.length) return;
      var selected = form.querySelector('[data-platform]:checked');
      platforms[0].setCustomValidity(selected ? '' : 'Select at least one platform.');
    }

    function syncProfileUrl() {
      if (!profileUrl) return '';
      var rest = profileRest(profileUrl.value);
      if (profileUrl.value.match(/^\s*https?:\/\//i)) profileUrl.value = rest;
      profileUrl.setCustomValidity(rest ? '' : 'Enter a profile URL.');
      return rest;
    }

    platforms.forEach(function (box) {
      box.addEventListener('change', syncPlatforms);
    });

    if (profileUrl) {
      profileUrl.addEventListener('input', function () {
        var rest = profileRest(profileUrl.value);
        if (profileUrl.value.match(/^\s*https?:\/\//i)) profileUrl.value = rest;
        if (rest) profileUrl.setCustomValidity('');
      });
    }

    function showSuccess() {
      form.hidden = true;
      var success = root.querySelector('[data-partnerships-success]');
      if (success) success.hidden = false;
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      syncPlatforms();
      var rest = syncProfileUrl();
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      if (profileUrlValue) profileUrlValue.value = 'https://' + rest;
      if (submitButton) submitButton.disabled = true;
      form.submit();
      showSuccess();
    });
  }

  document.querySelectorAll('[data-partnerships-apply]').forEach(function (root) {
    initVideo(root);
    initForm(root);
  });
})();
